import { z } from 'zod'
import { oc } from '@orpc/contract'

const favoriteEntrySchema = z.object({
  text: z.string(),
  at: z.string(),
  name: z.string().max(50).optional(),
})

const favoriteDocSchema = z.array(favoriteEntrySchema)

export const assistantFavoriteGet = oc
  .route({ method: 'GET', path: '/v2/assistant/favorite' })
  .input(z.object({}).optional())
  .output(favoriteDocSchema)

export const assistantFavoriteAdd = oc
  .route({ method: 'POST', path: '/v2/assistant/favorite' })
  .input(z.object({ text: z.string().min(1) }))
  .output(favoriteDocSchema)

export const assistantFavoriteUpdate = oc
  .route({ method: 'PATCH', path: '/v2/assistant/favorite' })
  .input(
    z.object({
      originalText: z.string().min(1),
      text: z.string().min(1),
      // Name semantics follow conventional PATCH partial-update rules:
      //   - field absent (undefined): preserve the existing label
      //   - explicit empty string ('' or whitespace): clear the label
      //   - non-empty string: set as the new label (trimmed server-side)
      name: z.string().max(50).optional(),
    }),
  )
  .output(favoriteDocSchema)

export const assistantFavoriteDelete = oc
  .route({ method: 'DELETE', path: '/v2/assistant/favorite' })
  .input(z.object({ text: z.string().min(1) }))
  .output(favoriteDocSchema)
